module.exports = __webpack_public_path__ + "img/eb5ce8b.jpg";